import InsectsIcon from 'components/Icons/InsectsIcon';

interface InsectsCellProps {
  amountInsects: number;
}
const InsectsCell: React.FC<InsectsCellProps> = ({ amountInsects: amount }) => {
  return (
    <div className="d-flex align-items-center">
      <InsectsIcon amount={amount} />
    </div>
  );
};

export default InsectsCell;
